import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import OwnerLogin from '@/pages/owner/Login';
import OwnerRegister from '@/pages/owner/Register';
import OwnerDashboard from '@/pages/owner/Dashboard';
import DriverLogin from '@/pages/driver/Login';
import DriverHome from '@/pages/driver/Home';
import DriverOrderDetail from '@/pages/driver/OrderDetail';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/owner/login" replace />} />
          <Route path="/owner/login" element={<OwnerLogin />} />
          <Route path="/owner/register" element={<OwnerRegister />} />
          <Route path="/owner/dashboard" element={<OwnerDashboard />} />
          <Route path="/driver/login" element={<DriverLogin />} />
          <Route path="/driver" element={<DriverHome />} />
          <Route path="/driver/order/:id" element={<DriverOrderDetail />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
